<template>
  <div>
    <div class="app-main__inner">
      <TituloComponente
        icono-titulo="fas fa-plus"
        texto-titulo="Nueva situacion de revista"
      />
      <div class="tab-content">
        <div
          class="tab-pane tabs-animation fade show active"
          id="tab-content-0"
          role="tabpanel"
        >
          <div class="row">
            <div class="col-lg-12">
              <div class="main-card mb-3 card">
                <div class="card-body">
                  <h5 class="card-title">Datos:</h5>
                  <form @submit.prevent="guardarSituacionRevista()">
                    <float-label label="Código:" clase>
                      <input
                        v-model="situacionrevista.codigo"
                        id="codigo"
                        placeholder="Ingresar un código..."
                        type="text"
                        class="form-control"
                        :class="
                          enviado && !$v.situacionRevista.codigo.required
                            ? 'is-invalid'
                            : ''
                        "
                      />
                      <template v-slot:validation>
                        <div
                          class="invalid-feedback"
                          v-if="enviado && !$v.situacionRevista.codigo.required"
                        >
                          Debe ingresar un código
                        </div>
                      </template>
                    </float-label>
                    <float-label label="Descripción:" clase="">
                      <input
                        id="descripcion"
                        v-model="situacionrevista.descripcion"
                        placeholder="Ingresar una descripción..."
                        type="text"
                        class="form-control"
                      />
                    </float-label>
                    <button class="mt-1 btn btn-info float-right">
                      Guardar
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponente from "@/components/layouts/TituloComponente";
import FloatLabel from "@/components/layouts/FloatLabel";
import { required } from "vuelidate/lib/validators";
import SituacionRevista from "@/models/situacionRevista";
import axios from "axios";
export default {
  name: "NuevaSituacionRevista",
  components: {
    TituloComponente,
    FloatLabel,
  },
  data() {
    return {
      situacionrevista: new SituacionRevista(null, "", ""),
    };
  },
  validations: {
    situacionRevista: {
      codigo: { required },
      descripcion: { required },
    },
  },
  methods: {
    guardarSituacionRevista() {
      axios
        .post("/situacionrevista", this.situacionrevista)
        .then((res) => {
          if (res.data.success) {
            this.$router.push({ name: "ListarSituacionRevista" });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>